import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux'
import { AuthService as auth } from './screens/services/firebase/firebaseServiceNEW';
import { changeUser } from "./screens/services/redux/actions";
import ProtectedRoute from './components/ProtectedRoute';

import Header from './screens/components/header';
import Footer from './screens/components/footer';
import Landing from './screens/Landing'
import GarageSearch from './screens/GarageSearch'
import GarageView from './screens/GarageView'
import GarageDetails from './screens/GarageDetails';
import GarageAdd from './screens/GarageAdd'
import GarageEdit from './screens/GarageEdit'
import AdvertisementView from './screens/ad_view'
import AdvertisementAdd from './screens/ad_add'
import AdvertisementEdit from './screens/ad_edit'
import SignIn from './screens/signIn'
import NegotiationsBar from './screens/components/negotiations_bar/NegotiationsBar'
import NotFound from './screens/NotFound'
import HowItWorks from './screens/HowItWorks';
import Offer from './screens/offer/Offer';
import UserAdd from './screens/user_add';
import ContactUs from './screens/ContactUs';
import ScrollToTop from './screens/components/ScrollToTop';
import PaymentPage from './screens/components/PaymentPage';
import PaymentSuccess from './screens/components/PaymentSuccess';
import PaymentGarageSuccess from './screens/components/PaymentGarageSuccess';
import UserReturnUrl from './screens/UserReturnUrl';

import AdminHeader from './screens/components/AdminHeader';
import EditPassword from './screens/admin/EditPassword';
import ZipCodes from './screens/admin/ZipCodes';
import AdminAdvertisement from './screens/admin/AdminAdvertisement';
import AdminGarages from './screens/admin/AdminGarages';
import UsersView from './screens/admin/UsersView';
import AdvertisementLanding from './screens/ad_landing';
import PaymentGrarage from './screens/components/PaymentGrarage';
import ViewContract from './screens/ViewContract';
import LeaseForm from './screens/LeaseForm';
import LeaseFormEdit from './screens/LeaseFormEdit';
import ReadContract from './screens/readContract';
import ViewPayment from './screens/ViewPayment';
import RenewAddvertisement from './screens/Renew_ad';
import Metatags from './Metatags/Metatags';

function App() {
  const isAuth = useSelector(state => state.user.role);
  const profile_complete = useSelector(state => state.user.profile_complete);
  const dispatch = useDispatch();

  // const [isDropdownActive, setIsDropdownActive1] = useState(false);
  const [authLoaded, setAuthLoaded] = useState(false);

  useEffect(() => {
    async function setUser({ uid, email, phoneNumber, role, profile_complete, userType }) {
      const reduxAction = changeUser({ uid, email, phoneNumber, role, profile_complete, userType });
      dispatch(reduxAction);
      setAuthLoaded(true);
      console.log('profile_complete', profile_complete)
    }
    auth.authPersistence(setUser);
  }, [dispatch, isAuth, profile_complete]);


  return (
    <>
      {authLoaded && (
        <>
          <BrowserRouter>
            <ScrollToTop />
            {isAuth === 'admin' ?
              <AdminHeader />
              :
              <Header />
            }
            {isAuth === 'user' ? <NegotiationsBar /> : ''}
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/about" element={
        <>
          <Metatags 
            title="Search - GarageXY"
            description="Learn about our mission to solve parking problems"
            keywords="parking company, about us, garagexy story"
          />
          <GarageSearch />
        </>
      } />

              <Route path="search" element={<GarageSearch />} />
              <Route path="contact-us" element={<ContactUs />} />
              <Route path="login" element={<SignIn />} />
              <Route path='ad-landing' element={<AdvertisementLanding />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/sign_up" element={<SignIn isSignUp={true} />} />
              <Route path="garages" element={
                isAuth === 'admin' ? <Navigate to='/manage-advertisement' /> : 
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <GarageView />
                </ProtectedRoute>
              } />
              <Route path="garages-add" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <GarageAdd />
                </ProtectedRoute>
              } />
              <Route path="garages-details/*" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <GarageDetails />
                </ProtectedRoute>
              } />
              <Route path="garage-edit/*" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <GarageEdit />
                </ProtectedRoute>
              } />
              <Route path='advertisement' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <AdvertisementView />
                </ProtectedRoute>
              } />
              <Route path='advertisement-add' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <AdvertisementAdd />
                </ProtectedRoute>
              } />
              <Route path='advertisement-edit/*' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <AdvertisementEdit />
                </ProtectedRoute>
              } />
              <Route path="/offer/*" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <Offer />
                </ProtectedRoute>
              } />
              <Route path="/edit_user" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <UserAdd />
                </ProtectedRoute>
              } />
              <Route path='/view-contract' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <ViewContract />
                </ProtectedRoute>
              } />
              <Route path='/leaseform/*' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <LeaseForm />
                </ProtectedRoute>
              } />
              <Route path='/leaseformedit/*' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <LeaseFormEdit />
                </ProtectedRoute>
              } />
              <Route path='/readcontract/*' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <ReadContract />
                </ProtectedRoute>
              } />
              <Route path='/viewpayment/*' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <ViewPayment />
                </ProtectedRoute>
              } />
              <Route path='/RenewAddvertisement/*' element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <RenewAddvertisement />
                </ProtectedRoute>
              } />
              <Route path="/advertise" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <AdvertisementView />
                </ProtectedRoute>
              } />
              <Route path="/payment" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <PaymentPage />
                </ProtectedRoute>
              } />
              <Route path="/garage-payment" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <PaymentGrarage />
                </ProtectedRoute>
              } />
              <Route path="/success-payment" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <PaymentGarageSuccess />
                </ProtectedRoute>
              } />
              <Route path="/return_url" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <UserReturnUrl />
                </ProtectedRoute>
              } />
              <Route path="/refresh_url" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <UserReturnUrl />
                </ProtectedRoute>
              } />


              <Route path="/change-password" element={(isAuth === 'admin' || isAuth === 'user') ? <EditPassword /> : <Navigate to='/login' />} />
              <Route path="/manage-garages" element={isAuth === 'admin' ? <AdminGarages /> : <Navigate to='/login' />} />
              <Route path="/manage-users" element={isAuth === 'admin' ? <UsersView /> : <Navigate to='/login' />} />
              <Route path="/manage-advertisement" element={isAuth === 'admin' ? <AdminAdvertisement /> : <Navigate to='/login' />} />
              <Route path="/zipcodes" element={isAuth === 'admin' ? <ZipCodes /> : <Navigate to='/login' />} />
              <Route path="/success" element={
                <ProtectedRoute isAuthenticated={isAuth === 'user'}>
                  <PaymentSuccess />
                </ProtectedRoute>
              } />
              <Route element={<NotFound />} />
            </Routes>
            <Footer />
          </BrowserRouter>
        </>
      )}

    </>

  );
}

export default App;
